import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class QrCodeGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    if (environment.qrcode === 'enabled') {
      return true
    } else {
      return this.router.createUrlTree(['/map'])
    }
  }
}
